import PropTypes from 'prop-types';
import defaultAriaProps from 'client/utils/constants/ariaPropTypes';

import styles from './ButtonGroup.module.scss';

const ButtonGroup = ({ children, className, ...props }) => {
    return (
        <div className={['govuk-button-group', styles.container, className].join(' ')} {...props}>
            {children}
        </div>
    );
};

ButtonGroup.propTypes = {
    ...defaultAriaProps,
    className: PropTypes.string
};

export default ButtonGroup;
